import React from 'react'
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import Spinner from '../../../Components/loader';
import { connect } from "react-redux";
import { createPoInwardProducts, showFixedDigitsValue, showStockValue } from '../../../actions';
import { toast } from 'react-toastify';
import parse from 'html-react-parser';
import Select from 'react-select';
import plus from "../../../assets/images/pl.svg";
import close from "../../../assets/images/close.svg";

class BulkUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            quotationId: "",
            items: [],
            inwardData: [],
            load: false,
            inwardValues: [],
            selectedPoOption: null,
            invoiceNumber: ''
        }
        this.productHandler = this.productHandler.bind(this);
        this.selectHandler = this.selectHandler.bind(this);
        this.selectProHandler = this.selectProHandler.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.changeBoxHandler = this.changeBoxHandler.bind(this);
        this.handleInvoiceNumberChange = this.handleInvoiceNumberChange.bind(this);
        this.submitHandler = this.submitHandler.bind(this);
    }
    selectHandler(e) {
        const { openedItem } = this.state;
        let newItems = openedItem.map((i) => i = e.target.checked);
        this.setState({
            openedItem: newItems,
        })
    }
    selectProHandler(e, index) {
        const { openedItem } = this.state;
        let newItems = openedItem.map((item, i) => index === i ? e.target.checked : item);
        this.setState({
            openedItem: newItems
        })
    }
    changeHandler = (e, index) => {
        const { data } = this.state;
        let a = Number(data[index].balance);
        let b = e.target.value;
        if (b && !/^([0-9]{1,5})+(\.[0-9]{0,2})?$/i.test(b)) {
            toast("Enter valid digits Ex(19.00,23456.45,200.34)");
            return false;
        } else if (+b <= a) {
            data[index].inwardQuantity = b;
            // data[index].balance = data[index].quantity - Number(e.target.value);
            this.setState({
                data: data
            })
        } else {
            toast("Pls enter the number less than or equal to  " + a);
        }
    }
    changeBoxHandler = (e, index) => {
        const { data } = this.state;
        let b = e.target.value;
        if (b && /[a-zA-Z]/.test(b)) {
            toast("Letters (uppercase and lowercase) are not allowed. Only numbers and special characters are allowed.");
            return false;
        }
        data[index].noOfBox = b;
        this.setState({
            data: data
        })
    }
    handleInvoiceNumberChange = (e) => {
        this.setState({ invoiceNumber: e.target.value });
    }
    productHandler(selectedOption) {
        if (!selectedOption) {
            this.setState({
                data: [],
                purchaseOrderId: undefined,
                inwardValues: [],
                selectedPoOption: null
            });
            return;
        }
        this.props.inwardData?.map((item) => {
            if (item?.purchaseOrderId == selectedOption.value) {
                const values = item?.projectProductList.map((val) => val.inwardQuantity);
                this.setState({
                    data: item?.projectProductList,
                    purchaseOrderId: item?.purchaseOrderId,
                    inwardValues: values,
                    selectedPoOption: selectedOption
                })
            }
        });
    }
    submitHandler() {
        const { data, invoiceNumber } = this.state;
        console.log("invoiceNumber", invoiceNumber);

        if (!invoiceNumber.trim()) {
            toast("Please enter a valid Invoice Number");
            return;
        }

        let pro = [];
        data?.map((item, i) => {
            let items = {};
            if (Number(item.inwardQuantity) !== 0) {
                items["projectProductId"] = item.purchaseProjectProductId;
                items["stockQty"] = Number(item.inwardQuantity);
                items["noOfBox"] = item.noOfBox || 0;
                items["invoiceNumber"] = invoiceNumber;
                pro.push(items);
            }
        });
        this.setState({
            load: true
        })
        this.props.dispatch(createPoInwardProducts(pro));
    }
    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show && this.props.show === true) {
            this.setState({
                data: [],
                invoiceNumber: '',
                inwardValues: [],
                selectedPoOption: null
            });
        }

        if (prevProps.inwardProductsSuccess !== this.props.inwardProductsSuccess) {
            const result = this.props.inwardProductsSuccess;
            if (result && result.status === 200) {
                this.setState({
                    data: []
                })
                toast(result.data);
                this.props.onHide();
                this.props.listData();
            } else if (result && result.status) {
                toast(result.data);
            }
        }
    }

    render() {
        const { show, onHide, inwardData, handleShow, load } = this.props;
        const { data, inwardValues } = this.state;
        return (
            <>
                <button className="add-stock" onClick={handleShow}>
                    <img src={plus} alt="" /> Bulk Upload
                </button>

                <Modal
                    show={show}
                    size="xl"
                    onHide={() => {
                        onHide();
                    }}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    backdrop="static"
                    keyboard={false}
                >
                    <div className="modal-staff">
                        <div className="head">
                            <div>
                                <i class="fas fa-arrow-left" onClick={() => {
                                    onHide();
                                }}></i>
                                <h4>BULK INWARD PRODUCT</h4>
                            </div>
                            <div>
                                <label className="counter-sale-label counter-sale-label-invoice">Invoice No:</label>
                                <input
                                    type="text"
                                    maxLength="50"
                                    className='convert_po_input counter-sale-input-invoice'
                                    value={this.state.invoiceNumber}
                                    onChange={this.handleInvoiceNumberChange}
                                />
                            </div>
                            <span style={{ marginLeft: 'auto' }} onClick={() => {
                                onHide();
                            }}>
                                <img src={close} alt="..." width="18px" style={{ cursor: "pointer" }} />
                            </span>
                        </div>
                        <div className='space-parts'>
                            <Select
                                placeholder="Select One"
                                value={this.state.selectedPoOption}
                                onChange={(opt) => this.productHandler(opt)}
                                options={Array.isArray(inwardData) ? inwardData.map((unit) => ({
                                    value: unit?.purchaseOrderId,
                                    label: unit?.purchaseOrderReferenceNumber
                                })) : []}
                                isSearchable={true}
                                isClearable={true}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                            />
                            {load && <Spinner />}
                        </div>
                        <div className="table-class space-part">
                            <table class="table table-borderless">
                                <thead>
                                    <tr>
                                        <th scope="col">
                                            Project
                                        </th>
                                        <th scope="col">
                                            Article No.
                                        </th>
                                        <th scope="col">
                                            Product
                                        </th>
                                        <th scope="col" className='txt-center'>
                                            Qty
                                        </th>
                                        <th scope="col" className='txt-center'>
                                            No of Box
                                        </th>
                                        <th scope="col" className='txt-center' >
                                            Inward
                                        </th>
                                        <th scope="col" className='txt-center'>
                                            Balance
                                        </th>
                                        <th scope="col" className='txt-center'>
                                            Available Stock
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className='hide_td'>
                                    {data?.length !== 0 ? data?.map((item, i) => (
                                        <tr key={i} >
                                            <td className="new_bulk_size">
                                                <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> {item.projectName || "-"}</Tooltip>}>
                                                    <span className="d-inline-block">
                                                        {item.projectName || "-"}
                                                    </span>
                                                </OverlayTrigger>
                                            </td>
                                            <td>{item?.articleId || "-"}</td>
                                            <td className="new_bulk_size">
                                                <OverlayTrigger overlay={<Tooltip id="tooltip-disabled"> {parse(item?.productName) || "-"}</Tooltip>}>
                                                    <span className="d-inline-block">
                                                        {parse(item?.productName) || "-"}
                                                    </span>
                                                </OverlayTrigger>
                                            </td>
                                            <td className='txt-center'>{item?.quantity}</td>
                                            <td className='txt-center'>
                                                <input type="text"
                                                    className='convert_po_input'
                                                    value={item?.noOfBox || ''}
                                                    onChange={(e) => this.changeBoxHandler(e, i)} />
                                            </td>
                                            <td className='txt-center'><input type="text"
                                                className='convert_po_input'
                                                value={item?.inwardQuantity}
                                                onChange={(e) => this.changeHandler(e, i)} /></td>
                                            <td className='txt-center'> {`${inwardValues[i] - item.inwardQuantity === 0 ? 0 : showFixedDigitsValue(inwardValues[i], item.inwardQuantity)}`} </td>
                                            <td className='txt-center'>{`${showStockValue(item.inwardQuantity, item?.availableStock)}`}</td>
                                        </tr >
                                    )) : <h1 className="empty-data">No Records Found</h1>
                                    }
                                </tbody>
                            </table >
                        </div >
                        <center style={{ padding: "15px" }}>
                            {!load ?
                                <button className="customer-btn col-md-6" disabled={data?.length === 0} onClick={() => this.submitHandler()}>Add To Stock</button>
                                : <button className="customer-btn col-md-6">Loading...</button>}
                        </center >
                    </div >
                </Modal >
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        convertBoqList: state.boq.convertBoqList,
        inwardData: state.po.inwardData,
        load: state.po.load,
        confirmQuotDropdown: state.boq.confirmQuotDropdown,
        confirmQuotProduct: state.boq.confirmQuotProduct,
        addInwardData: state.po.addInwardData,
        inwardProductsSuccess: state.po.inwardProductsSuccess
    }
}

export default connect(mapStateToProps)(BulkUpload);
